import type { Course } from '@/lib/courses'

type PricedCourse = Pick<Course, 'price' | 'earlyBirdPrice' | 'discountedPrice'>

type PromotedCourse = Pick<Course, 'earlyBirdPrice' | 'discountedPrice' | 'promoPriceLabel'>

function parseBdtAmount(price: string | undefined): number | null {
  if (!price) {
    return null
  }

  const amount = Number(price.replace(/[^\d]/g, ''))
  return Number.isFinite(amount) && amount > 0 ? amount : null
}

export function formatBdtAmount(amount: number): string {
  return `৳${amount.toLocaleString('en-US')}`
}

export function getCourseSavings(course: PricedCourse) {
  const regular = parseBdtAmount(course.price)
  const promo = parseBdtAmount(course.earlyBirdPrice || course.discountedPrice)

  if (!regular || !promo || promo >= regular) {
    return null
  }

  const amount = regular - promo
  const percent = Math.round((amount / regular) * 100)

  return {
    amount,
    amountLabel: formatBdtAmount(amount),
    percentLabel: `${percent}%`,
    shortLabel: `Save ${formatBdtAmount(amount)} (${percent}%)`,
  }
}

export function getPromoPrice(course: PromotedCourse) {
  const price = course.earlyBirdPrice || course.discountedPrice
  if (!price) {
    return null
  }

  return {
    price,
    label: course.promoPriceLabel ?? (course.earlyBirdPrice ? 'Early Bird' : 'Discount'),
  }
}
